"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var UNITS = require('../../constant/chemical/units.constant');

var Product = /*#__PURE__*/function () {
  function Product(opt) {
    _classCallCheck(this, Product);

    this.productNumber = null;
    this.quantity = 1;
    this.size = null;
    this.unit = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(Product, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.productNumber = opt.productNumber || null;
      this.quantity = opt.quantity || 1;
      this.size = opt.size || null;
      this.unit = opt.unit || null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Product.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'product.schema.json',
        type: 'object',
        properties: {
          productNumber: {
            type: 'string'
          },
          quantity: {
            type: 'number'
          },
          size: {
            type: ['number', 'null']
          },
          unit: {
            anyOf: [{
              "enum": UNITS.map(function (unit) {
                return unit.value;
              })
            }, 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Product;
}();

module.exports = Product;